import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';
import { Tooltip } from '../Tooltip';

export const HeaderCellStyled = styled.th<{
  width?: string;
  isSortableColumn: boolean;
  isScrollable?: boolean;
  borderRadius?: string;
}>`
  padding-left: 20px;
  margin-right: 10px;
  ${(props) => props.width && `width: ${props.width}`};
  padding: 10px 0px 10px 20px;
  ${(props) => (props.isSortableColumn ? '' : 'padding-right: 20px;')}
  position: relative;
  &:not(:last-child):before {
    position: absolute;
    content: '';
    height: 26px;
    border-right: 1px solid
      ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
    right: 0px;
  }
  border-bottom: 1px solid
    ${(props) => props.theme.atlas.semantic.color.action.primary.hover};
  &:first-child {
    ${(props) =>
      props.borderRadius && `border-top-left-radius: ${props.borderRadius};`}
  }
  &:last-child {
    ${(props) =>
      props.borderRadius && `border-top-right-radius: ${props.borderRadius};`}
  }
`;

export const StyledText = styled.p`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.caption)};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  align-self: center;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const HeaderTextWithTooltipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const ContentContainer = styled.div<{
  isSortableColumn: boolean;
}>`
  display: flex;
  justify-content: space-between;
  height: 26px;
  cursor: ${({ isSortableColumn }) =>
    isSortableColumn ? 'pointer' : 'default'};
  align-items: center;
`;

export const StyledTooltip = styled(Tooltip)`
  margin-left: -8px;
`;
